import styled from 'styled-components';
import { media, layout } from 'src/components/base';
import { DropdownToggle } from '@prisjakt/ui/dropdown';
import { ListItem as DropdownItemComponent } from 'src/components/dropdown-new/item';

const SAVED_LIST_HEIGHT = '230px';

export const StyledProductActionButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: ${layout.measurements.spacing050};

  ${media.mediumOnly`
  grid-template-columns: 1fr;
`}
`;

export const StyledActionButton = styled.div`
  min-width: 0;
  width: 100%;
`;

export const StyledSavedListWrapper = styled.div`
  overflow-y: auto;
  width: fit-content;
  max-height: ${SAVED_LIST_HEIGHT};
  margin-left: ${layout.measurements.spacing050};
`;

export const StyledDropdownItem = styled(DropdownItemComponent)`
  max-width: 200px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: ${layout.measurements.spacing050} ${layout.measurements.spacing100};
`;

export const StyledDropdownToggleButton = styled(DropdownToggle)`
  && {
    width: 100%;
  }
`;
